import { FunctionComponent } from 'react';
import styled from '@emotion/styled';

const ApplicationLayoutContentContainer = styled.div`
    flex-grow: 1;
    position: relative;
`;

const ApplicationLayoutContent: FunctionComponent = ({ children }) => (
    <ApplicationLayoutContentContainer>{children}</ApplicationLayoutContentContainer>
);

export default ApplicationLayoutContent;
